(() => {
  if (customElements.get('parana-color-toggle')) return;
  const root = document.documentElement;
  const system = matchMedia('(prefers-color-scheme: dark)');
  let preference;
  try { preference = localStorage.getItem('parana-color-mode'); } catch (_) {}
  const valid = value => value === 'light' || value === 'dark';
  const apply = () => {
    const mode = valid(preference) ? preference : system.matches ? 'dark' : 'light';
    root.dataset.colorMode = mode;
    root.style.colorScheme = mode;
    document.querySelectorAll('parana-color-toggle').forEach(toggle => toggle.sync());
  };
  system.addEventListener('change', () => { if (!valid(preference)) apply(); });
  window.addEventListener('storage', event => {
    if (event.key === 'parana-color-mode' || event.key === null) { preference = event.newValue; apply(); }
  });
  customElements.define('parana-color-toggle', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      this.button = this.querySelector('button');
      this.button.hidden = false;
      this.sync();
      this.button.addEventListener('click', () => {
        preference = root.dataset.colorMode === 'dark' ? 'light' : 'dark';
        try { localStorage.setItem('parana-color-mode', preference); } catch (_) {}
        apply();
      }, { signal: this.cleanup.signal });
    }
    sync() {
      if (!this.button) return;
      const dark = root.dataset.colorMode === 'dark';
      this.button.setAttribute('aria-pressed', String(dark));
    }
    disconnectedCallback() { this.cleanup?.abort(); }
  });
  apply();
})();
